// extracted by mini-css-extract-plugin
module.exports = {"emptyFeatured":"EmptyImage_emptyFeatured__cJv_l","empty":"EmptyImage_empty__m_v_i"};